module.exports = __webpack_public_path__ + "static/media/Catalog_Template_A.ab7c9bca.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateProductWizard/images/Catalog_Template_A.JPG
// module id = 1076
// module chunks = 0